var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-container"},[(_vm.userRole === 'PSYCHOLOGIST')?_c('calendar-psychologist'):(_vm.userRole === 'PATIENT')?_c('calendar-patient'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }